module.exports = __webpack_public_path__ + "371966d547419a20e127834d4adb50a3.jpg";